import axiosInstance from "../axiosInstance";


export const sendEmail = (data) => {
    axiosInstance("send-email/", {
        baseURL: "https://greens-hugk.onrender.com/",
        method: "POST",
        data: data
    }).then(res => {
        alert("Thanks for your Interest! We will get back to you soon.")
    }).catch(err => { })
}